import React from 'react';
import ConfiguracoesListagemModal from './ConfiguracoesListagemModal';
import SalvarConfiguracaoModal from './SalvarConfiguracaoModal';

const ListagemConfiguracaoModais = ({
  showListagemModal,
  fecharListagemModal,
  configs,
  loadingListagem,
  selecionarConfig,
  excluirConfig,
  loadingExcluirId,
  showSalvarModal,
  fecharSalvarModal,
  salvarConfig,
  loadingSalvar,
  podeSalvarGeral
}) => (
  <>
    <ConfiguracoesListagemModal
      show={showListagemModal}
      onClose={fecharListagemModal}
      configs={configs}
      loading={loadingListagem}
      onSelecionar={selecionarConfig}
      onExcluir={excluirConfig}
      loadingExcluirId={loadingExcluirId}
    />

    <SalvarConfiguracaoModal
      show={showSalvarModal}
      onClose={fecharSalvarModal}
      onSalvar={salvarConfig}
      loading={loadingSalvar}
      podeSalvarGeral={podeSalvarGeral}
    />
  </>
);

export default ListagemConfiguracaoModais;
